import React, { Component } from "react";
import { Card, Row, Col, Form, Alert } from "react-bootstrap";
import api from "../../services/api";
import * as Sentry from "@sentry/react";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { getDataAtual, formataDataHoraExibicao } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import logomarca from '../../assets/images/logomarca.png';

import { setupDebugFromQuery } from '../../debugger';

import { getConfig } from "../../common/config";

function sentryCaptureIfNetworkIssue(error, extra = {}) {
  try {
    const status = error?.response?.status;
    const dataCode = error?.response?.data?.code;
    const isTimeout =
      error?.code === "ERR_CANCELED" ||
      error?.message === "timeout" ||
      error?.name === "CanceledError";

    const cfRay =
      error?.response?.headers?.["cf-ray"] || error?.response?.headers?.["CF-Ray"];
    const cfMitigated = error?.response?.headers?.["cf-mitigated"];
    const isWaf = !!(cfRay || cfMitigated);

    // ignora 403 esperado de sessão expirada
    if (dataCode === "token_not_valid") return;

    // só reporta timeout/abort ou sinais de WAF/Cloudflare
    if (!(isTimeout || isWaf)) return;

    Sentry.withScope((scope) => {
      scope.setTag("feature", "termos_aceite");
      if (status) scope.setTag("http.status", String(status));
      if (cfRay) scope.setTag("cf.ray", cfRay);
      if (cfMitigated) scope.setTag("cf.mitigated", cfMitigated);
      Object.entries(extra).forEach(([k, v]) => scope.setTag(k, String(v)));
      Sentry.captureException(isTimeout ? new Error("termos-timeout/abort") : error);
    });
  } catch {}
}

function captureOptinError(error, ctx = {}) {
  const {
    atendimento_uuid,
    etapa_id,
    proximaEtapaId,
    optin_data,
    is_mobile,
    client_platform,
  } = ctx;

  return Sentry.withScope((scope) => {
    // Tags para filtrar no Sentry
    scope.setTag('feature', 'termos_aceite');
    scope.setTag('where', 'submit_programa');
    if (etapa_id != null) scope.setTag('etapa_id', String(etapa_id));
    if (proximaEtapaId != null) scope.setTag('proxima_etapa_id', String(proximaEtapaId));
    if (is_mobile != null) scope.setTag('is_mobile', String(!!is_mobile));
    if (client_platform) scope.setTag('client_platform', client_platform);

    // Contexto útil
    const status = error?.response?.status ?? null;
    const requestUrl = error?.config?.url ?? null;
    const requestMethod = error?.config?.method ?? null;
    const responseData = error?.response?.data ?? null;
    const requestHeaders = error?.config?.headers ?? null;
    const ua = navigator.userAgent || '';

    if (status) scope.setTag('http.status', String(status));
    if (requestUrl) scope.setContext('request', { url: requestUrl, method: requestMethod });
    scope.setContext('payload', {
      atendimento_uuid,
      optin_data,
      etapa_id,
      proxima_etapa_id: proximaEtapaId ?? null,
    });
    scope.setContext('http', {
      status,
      responseData,           // ⚠️ cuidado pra não vazar PII — ok se o back retorna mensagens genéricas
      requestHeaders: {
        // filtre cabeçalhos sensíveis:
        ...(requestHeaders?.['X-USERNAME'] ? { 'X-USERNAME': '[redacted]' } : {}),
      },
      userAgent: ua,
    });

    // Um breadcrumb ajuda na linha do tempo
    scope.addBreadcrumb({
      category: 'action',
      message: 'Aceitar termos do programa',
      level: 'info',
      data: { atendimento_uuid, etapa_id, proximaEtapaId },
    });

    return Sentry.captureException(error);
  });
}

/**
 * Renderiza o texto de um checkbox personalizado, substituindo {link} por um <a> se configurado.
 */
function renderCheckboxTexto(checkbox) {
    const { texto, link } = checkbox;
    if (link && texto.includes('{link}')) {
        const partes = texto.split('{link}');
        return (
            <span>
                {partes[0]}
                <a href={link.url} target="_blank" rel="noopener noreferrer">{link.texto}</a>
                {partes[1] || ''}
            </span>
        );
    }
    return <span>{texto}</span>;
}

class TermosAceite extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.handleOptinChange = this.handleOptinChange.bind(this);
        this.handleSubmitOptin = this.handleSubmitOptin.bind(this);
        this.handleSubmitOptinLaboratorio = this.handleSubmitOptinLaboratorio.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            titulo: '',
            texto: '',
            etapa_id: '',
            etapa_midias_contato: '',
            etapa_momento_envio: '',
            etapa_tipo_envio: '',
            programa_id: '',
            programa_nome: '',
            programa_imagem_branca: '',
            programa_termo_paciente_pdf: '',
            termo_paciente_pdf_comprovante: '',
            programa_termo_id: '',
            etapas_atendimento: [],
            etapa_atual: [],
            optin_data: '',
            optin_data_laboratorio: '',
            option_ip: '',
            erroLoadRegistro: "",
            termo_id: "",
            pdf_termo_prestador: "",
            termo_prestador_pdf_comprovante: "",
            lets_sign_documento_id: "",
            atendimento_uuid: "",
            titulo_pagina: "",
            etapa_atendimento_id: '',
            termo_programa_pdf: '',
            loading: false,
            optinChecked: false,  // Estado do checkbox (fallback padrão)
            checkboxesState: {},  // Estado dos checkboxes personalizados { id: true/false }
            isIOS: false,
            debugEnabled: false,
            forceIOS: false,
            isMobile: false,
            consentChiesi: false,
            consentResultados: false,
            programa_dados: [],
            beneficiario_id: '',
            campos_aceite_termos: [],
            extra_valores_list: [],
            valoresCamposExtraPaciente: {},
        };

        this.abortCtrl = null;
    }

    componentDidMount(){
        const uuid = this.props.router.params.id;
        const searchParams = new URLSearchParams(this.props.router.location.search);
        const termoParam = searchParams.get('termo') || 'programa';

        const dbg = setupDebugFromQuery();
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

        this.setState({ 
            isIOS: dbg.enabled ? (dbg.forceIOS ? true : isIOS) : isIOS,
            debugEnabled: dbg.enabled,
            forceIOS: dbg.forceIOS
        });

        dbg.enabled && dbg.log('page:init', { path: location.pathname, search: location.search });

        if(uuid){
            this.setState({
                atendimento_uuid: uuid,
                titulo_pagina: 'Aceite de Termo',
                loading: true,
                erroLoadRegistro: ''
            })

            let config = {
                headers: {
                    'X-USERNAME': import.meta.env.VITE_X_USERNAME,
                }
            }

            // --- Timeout/Abort de rede ---
            this.abortCtrl = new AbortController();
            const ac = this.abortCtrl;
            config.signal = ac.signal;
            const watchdog = setTimeout(() => ac.abort('timeout'), 12000);

            //consulta os dados do programa na api
            api.get(`/termos/atendimento/${uuid}`, config)
            .then(response => {
                const dados = response.data;

                if (this.state.debugEnabled) {
                    try {
                        if (this.state.debugEnabled) {
                            const pdfProg = this.state.optin_data 
                                ? this.state.termo_paciente_pdf_comprovante 
                                : (this.state.programa_termo_paciente_pdf || this.state.termo_programa_pdf);

                            const pdfLab  = this.state.optin_data_laboratorio
                                ? this.state.termo_prestador_pdf_comprovante
                                : this.state.pdf_termo_prestador;

                            dbg.log('pdf:urls', { pdfPrograma: pdfProg, pdfLaboratorio: pdfLab });
                            if (pdfProg) { try { dbg.testPdf(pdfProg); } catch(_) {} }
                            if (pdfLab)  { try { dbg.testPdf(pdfLab); } catch(_) {} }
                        }
                    } catch(_) {}
                }

                //preenche os inputs
                console.log('[TERMOS-DEBUG] resposta completa:', JSON.stringify(dados));
                console.log('[TERMOS-DEBUG] campos_aceite_termos:', dados.campos_aceite_termos);
                console.log('[TERMOS-DEBUG] extra_valores_list:', dados.extra_valores_list);
                console.log('[TERMOS-DEBUG] beneficiario_id:', dados.beneficiario_id);
                console.log('[TERMOS-DEBUG] programa_id:', dados.programa_id);
                const camposAceiteTermos = Array.isArray(dados.campos_aceite_termos) ? dados.campos_aceite_termos : [];
                const extraValoresList = Array.isArray(dados.extra_valores_list) ? dados.extra_valores_list : [];
                const valoresCamposExtraPaciente = this.buildInitialCamposValues(camposAceiteTermos, extraValoresList);

                this.setState({
                    loading: false,
                    erroLoadRegistro: '',
                    programa_nome: dados.programa__nome,
                    programa_id: dados.programa_id,
                    programa_imagem_branca: dados.programa__imagem_branca,
                    programa_termo_paciente_pdf: dados.programa__termo_paciente_pdf,
                    termo_paciente_pdf_comprovante: dados.termo_paciente_pdf_comprovante,
                    programa_termo_id: dados.programa__termo_id,
                    etapa_id: dados.etapa_id,
                    etapa_midias_contato: dados.etapa__midias_contato,
                    etapa_momento_envio: dados.etapa__momento_envio,
                    etapa_tipo_envio: dados.etapa__tipo_envio,
                    etapa_atendimento_id: (dados.atendimento_etapa && dados.atendimento_etapa.id) ? dados.atendimento_etapa.id : '',
                    etapas_atendimento: dados.etapas,
                    termo_id: dados.programa__termo_id,
                    optin_data: dados.optin_data,
                    optin_data_laboratorio: dados.optin_data_laboratorio,
                    optin_ip: dados.optin_ip,    
                    pdf_termo_prestador: dados.pdf_termo_prestador,    
                    termo_prestador_pdf_comprovante: dados.termo_prestador_pdf_comprovante,    
                    lets_sign_documento_id: dados.lets_sign_documento_id,
                    termo_programa_pdf: dados.termo_programa_pdf,
                    termoParam: (termoParam != 'laboratorio') ? 'programa' : termoParam, // Guardar o valor do parâmetro
                    beneficiario_id: dados.beneficiario_id || '',
                    campos_aceite_termos: camposAceiteTermos,
                    extra_valores_list: extraValoresList,
                    valoresCamposExtraPaciente,
                })

                const searchParams = new URLSearchParams(this.props.router.location.search);
                const programa_uuid = searchParams.get('p') || dados.programa_id;

                if(programa_uuid) {
                    this.carregaDadosPrograma(programa_uuid);
                }

            })
            .catch(error => {

                const ua = navigator.userAgent || '';
                sentryCaptureIfNetworkIssue(error, {
                    client_platform: /Android/i.test(ua) ? 'Android' : /iPhone|iPad|iPod/i.test(ua) ? 'iOS' : 'Desktop',
                    is_mobile: this.state.isMobile
                });

                let erro_msg = 'Erro ao consultar atendimento, tente novamente';
                if (error?.message === 'timeout' || error?.name === 'CanceledError') {
                    erro_msg = 'Tempo de conexão excedido. Toque em "Recarregar" ou tente abrir em outro navegador.';
                } else if (error?.response?.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                } else if (error?.response?.status === 403) {
                    erro_msg = 'Acesso bloqueado pela rede/antibot. Abra em navegador externo ou outra rede.';
                }

                if (this.state.debugEnabled) {
                    const dbg = setupDebugFromQuery(); // seguro chamar de novo
                    dbg.log('api:error', {
                        url: `/termos/atendimento/${uuid}`,
                        status: error?.response?.status,
                        data: error?.response?.data
                    });
                }

                this.setState({
                    loading: false,
                    erroLoadRegistro: erro_msg,
                })
            })
            .finally(() => {
                clearTimeout(watchdog);
                this.setState({ loading: false });
            });
        }

        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    }

    carregaDadosPrograma = (programa_uuid) => {     
        let config = {
            headers: {
                'X-USERNAME': import.meta.env.VITE_X_USERNAME,
            }
        }

        api.get(`/programas/${programa_uuid}/`, config)
        .then(response => {
            const programaDados = response.data;
            this.setState({ programa_dados: programaDados });

            // Inicializa o state dos checkboxes personalizados se existirem
            const checkboxes = getConfig(programaDados.configuracoes, 'aceite_termos.checkboxes_personalizados', null);
            if (checkboxes && Array.isArray(checkboxes) && checkboxes.length > 0) {
                const initialState = {};
                checkboxes.forEach(cb => {
                    initialState[cb.id] = false;
                });
                this.setState({ checkboxesState: initialState });
            }
        })
        .catch(error => {
            console.error('Erro ao carregar dados do programa atual:', error);
            
            window.location.href = `/login/?error=2&p=${programa_uuid}`;
        });
    };

    checkMobile = () => {
        const ua = navigator.userAgent || '';
        const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const isAndroid = /Android/i.test(ua);
        const isIOS = /iPad|iPhone|iPod/i.test(ua);
        const isInApp = /(FBAN|FBAV|Instagram|Line\/|Twitter|FB_IAB)/i.test(ua); // webviews comuns
        const byWidth = window.innerWidth < 768;
        this.setState({ isMobile: byWidth || isAndroid || isIOS || isInApp });
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.checkMobile);

        // Cancela requisição pendente ao sair
        if (this.abortCtrl) {
            try { this.abortCtrl.abort('unmount'); } catch(_) {}
        }
    }

    handleOptinChange(e) {
        this.setState({ optinChecked: e.target.checked });
    }
    
    /**
     * Handler para checkboxes personalizados
     */
    handleCustomCheckboxChange = (checkboxId) => (e) => {
        this.setState(prevState => ({
            checkboxesState: {
                ...prevState.checkboxesState,
                [checkboxId]: e.target.checked
            }
        }));
    }

    /**
     * Verifica se todos os checkboxes obrigatórios estão marcados.
     * Se usar checkboxes personalizados, valida por eles. Se não, usa o optinChecked padrão.
     */
    todosCheckboxesMarcados = () => {
        const checkboxes = getConfig(
            this.state.programa_dados?.configuracoes, 
            'aceite_termos.checkboxes_personalizados', 
            null
        );

        if (checkboxes && Array.isArray(checkboxes) && checkboxes.length > 0) {
            const obrigatorios = checkboxes.filter(cb => cb.obrigatorio !== false);
            return obrigatorios.every(cb => this.state.checkboxesState[cb.id] === true);
        }

        // Fallback: checkbox padrão
        return this.state.optinChecked;
    }

    handleSubmitOptin() {
        const MySwal = withReactContent(Swal);

        const campoObrigatorioPendente = this.validateCamposAceiteObrigatorios();
        if (campoObrigatorioPendente) {
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção!',
                html: `Preencha o campo obrigatório: <strong>${campoObrigatorioPendente}</strong>.`
            });
            return;
        }

        if (!this.todosCheckboxesMarcados()) {
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção!',
                html: 'Você precisa aceitar os termos e marcar todas as declarações obrigatórias para continuar.'
            });
            return;
        }   

        this.setState({
            loading: true
        })

        const dataAtual = getDataAtual();

        const indiceEtapaAtual = this.state.etapas_atendimento.findIndex(etapa => etapa.id === this.state.etapa_id);

        // Verificar se existe uma próxima etapa
        const proximaEtapa = indiceEtapaAtual >= 0 && indiceEtapaAtual < this.state.etapas_atendimento.length - 1 
        ? this.state.etapas_atendimento[indiceEtapaAtual + 1] 
        : null;

        const basePayload = {
            optin_data: dataAtual,
            etapa_id: this.state.etapa_id,
            ...(proximaEtapa?.id ? { proxima_etapa_id: proximaEtapa.id } : {}),
        };

        const submitPayload = this.buildSubmitPayloadWithCamposExtras(basePayload);

        api.put(`/termos/atendimento/${this.state.atendimento_uuid}/`, 
            submitPayload.data,
            submitPayload.config
        )
        .then(response => {
            const dados = response.data;

            const mensagem_sucesso = getConfig(this.state.programa_dados.configuracoes, 'aceite_termos.mensagem_aceite_paciente', '');

            this.setState({
                loading: false,
                optin_data: dataAtual,
                termo_paciente_pdf_comprovante: dados.termo_paciente_pdf_comprovante
            });
            MySwal.fire({
                icon: 'success',
                showCloseButton: true,
                title: 'Termo Aceito!',
                html: mensagem_sucesso || 'O Termo do Programa foi aceito com sucesso!'
            });
        })
        .catch(error => {
            const ua = navigator.userAgent || '';
            const client_platform = /Android/i.test(ua) ? 'Android' : /iPhone|iPad|iPod/i.test(ua) ? 'iOS' : 'Desktop';

            sentryCaptureIfNetworkIssue(error, {
                where: 'submit_programa',
                client_platform: client_platform,
                is_mobile: this.state.isMobile
            });

            const eventId = captureOptinError(error, {
                atendimento_uuid: this.state.atendimento_uuid,
                etapa_id: this.state.etapa_id,
                proximaEtapaId: proximaEtapa?.id ?? null,
                optin_data: dataAtual,
                is_mobile: this.state.isMobile,
                client_platform,
            });

            this.setState({
                loading: false
            });
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção!',
                html: 'Houve um erro ao aceitar os termos, por favor, tente novamente ou contate a administração'
            });
        });
    }


    handleSubmitOptinLaboratorio() {
        const MySwal = withReactContent(Swal);

        if (!this.state.optinChecked) {
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção!',
                html: 'Você precisa aceitar os termos para continuar'
            });
            return;
        }

        this.setState({
            loading: true
        })

        const dataAtual = getDataAtual();

        // Só avança a etapa se o laboratório tiver termo de fato (PDF ou LetsSign)
        const labTemTermo = !!(this.state.pdf_termo_prestador || this.state.lets_sign_documento_id);

        const indiceEtapaAtual = this.state.etapas_atendimento.findIndex(etapa => etapa.id === this.state.etapa_id);

        const proximaEtapa = (labTemTermo && indiceEtapaAtual >= 0 && indiceEtapaAtual < this.state.etapas_atendimento.length - 1)
            ? this.state.etapas_atendimento[indiceEtapaAtual + 1]
            : null;

        api.put(`/termos/atendimento/${this.state.atendimento_uuid}/`,
            {
                optin_data_laboratorio: dataAtual,
                etapa_id: this.state.etapa_id,
                ...(proximaEtapa?.id ? { proxima_etapa_id: proximaEtapa.id } : {}),
            },
            {
                headers: {
                    'X-USERNAME': import.meta.env.VITE_X_USERNAME,
                }
            }
        )
        .then(response => {
            const dados = response.data;
            
            this.setState({
                loading: false,
                optin_data_laboratorio: dataAtual,
                termo_prestador_pdf_comprovante: dados.termo_prestador_pdf_comprovante,
            });
            MySwal.fire({
                icon: 'success',
                showCloseButton: true,
                title: 'Termo Aceito!',
                html: 'O Termo de Consentimento do Laboratório foi aceito com sucesso!'
            });
        })
        .catch(error => {

            const ua = navigator.userAgent || '';
            sentryCaptureIfNetworkIssue(error, {
                where: 'submit_laboratorio',
                client_platform: /Android/i.test(ua) ? 'Android' : /iPhone|iPad|iPod/i.test(ua) ? 'iOS' : 'Desktop',
                is_mobile: this.state.isMobile
            });

            this.setState({
                loading: false
            });
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção!',
                html: 'Houve um erro ao aceitar os termos, por favor, tente novamente ou contate a administração'
            });
        });
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    buildInitialCamposValues = (campos = [], extraValores = []) => {
        const bySlug = {};
        const byCampoId = {};

        (extraValores || []).forEach((item) => {
            if (item && item.campo_slug) bySlug[item.campo_slug] = item.valor;
            if (item && item.campo_id != null) byCampoId[String(item.campo_id)] = item.valor;
        });

        const valores = {};
        (campos || []).forEach((campo) => {
            const key = String(campo.id);
            const valorById = byCampoId[key];
            const valorBySlug = bySlug[campo.slug];
            valores[campo.id] = valorById !== undefined ? valorById : (valorBySlug !== undefined ? valorBySlug : (campo.valor || ''));
        });

        return valores;
    };

    parseCampoOpcao = (linha) => {
        const [valorRaw, labelRaw] = String(linha || '').split(':');
        const valor = (valorRaw || '').trim();
        const label = (labelRaw || valor).trim();
        return { valor, label };
    };

    handleChangeCampoAceite = (id, value) => {
        const isEvent = value && value.target;
        let finalValue = value;

        if (isEvent) {
            const target = value.target;

            if (target.type === 'file') {
                finalValue = target.files && target.files[0] ? target.files[0] : null;
            }
            else if (target.type === 'checkbox') {
                const valoresAnteriores = this.state.valoresCamposExtraPaciente?.[id]
                    ? String(this.state.valoresCamposExtraPaciente[id]).split(',').map((v) => v.trim()).filter(Boolean)
                    : [];
                const valorAtual = target.value;

                let novosValores;
                if (target.checked) {
                    novosValores = [...valoresAnteriores, valorAtual].filter((v, i, arr) => arr.indexOf(v) === i);
                } else {
                    novosValores = valoresAnteriores.filter((v) => v !== valorAtual);
                }

                finalValue = novosValores.join(',');
            }
            else {
                finalValue = target.value;
            }
        }

        this.setState((prevState) => ({
            valoresCamposExtraPaciente: {
                ...prevState.valoresCamposExtraPaciente,
                [id]: finalValue,
            },
        }));
    };

    validateCamposAceiteObrigatorios = () => {
        const campos = this.state.campos_aceite_termos || [];
        const slugToId = {};
        campos.forEach((c) => { slugToId[c.slug] = c.id; });

        const isCampoVisivel = (campo) => {
            const mascara = campo.mascara || '';
            const showOnMatch = mascara.match(/show-on\[campo_extra=([^|]+)\|campo_valor=([^\]]+)\]/);
            if (!showOnMatch) return true;
            const refId = slugToId[showOnMatch[1]];
            if (refId == null) return false;
            return String(this.state.valoresCamposExtraPaciente?.[refId] ?? '') === showOnMatch[2];
        };

        const isCampoInformativo = (campo) => String(campo.mascara || '').includes('information-field');
        const camposObrigatorios = campos.filter((campo) => !isCampoInformativo(campo) && isCampoVisivel(campo));

        for (const campo of camposObrigatorios) {
            const valor = this.state.valoresCamposExtraPaciente?.[campo.id];

            if (campo.tipo === 'arquivo') {
                if (!(valor instanceof File) && !valor) {
                    return campo.nome;
                }
            } else if (campo.tipo === 'checkbox') {
                if (!String(valor || '').trim()) {
                    return campo.nome;
                }
            } else if (!String(valor ?? '').trim()) {
                return campo.nome;
            }
        }

        return null;
    };

    buildSubmitPayloadWithCamposExtras = (basePayload) => {
        const headers = {
            'X-USERNAME': import.meta.env.VITE_X_USERNAME,
        };

        const campos = this.state.campos_aceite_termos || [];
        if (!campos.length) {
            return {
                data: basePayload,
                config: { headers },
            };
        }

        let hasFile = false;
        const extrasObject = {};
        const formData = new FormData();

        Object.entries(basePayload || {}).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                formData.append(key, value);
            }
        });

        let cont = 1;
        campos.forEach((campo) => {
            const valor = this.state.valoresCamposExtraPaciente?.[campo.id];

            if (valor instanceof File) {
                hasFile = true;
                formData.append(`extra_valor_arquivo_${cont}`, valor);
            } else if (typeof valor === 'boolean') {
                const boolString = valor ? 'true' : 'false';
                formData.append(`extra_valor_valor_${cont}`, boolString);
                extrasObject[`extra_valor_valor_${cont}`] = boolString;
            } else {
                const valorString = valor == null ? '' : String(valor);
                formData.append(`extra_valor_valor_${cont}`, valorString);
                extrasObject[`extra_valor_valor_${cont}`] = valorString;
            }

            formData.append(`extra_valor_campo_id_${cont}`, campo.id);
            extrasObject[`extra_valor_campo_id_${cont}`] = campo.id;
            cont += 1;
        });

        if (hasFile) {
            return {
                data: formData,
                config: { headers },
            };
        }

        return {
            data: {
                ...basePayload,
                ...extrasObject,
            },
            config: { headers },
        };
    };

    renderCamposAceiteTermos = () => {
        console.log('[TERMOS-DEBUG] renderCamposAceiteTermos chamado', {
            termoParam: this.state.termoParam,
            optin_data: this.state.optin_data,
            campos_count: (this.state.campos_aceite_termos || []).length,
        });
        if (this.state.termoParam !== 'programa') return null;
        if (this.state.optin_data) return null;

        const campos = this.state.campos_aceite_termos || [];
        if (!campos.length) return null;

        // Mapeia slug -> id para lookup de show-on
        const slugToId = {};
        campos.forEach((c) => { slugToId[c.slug] = c.id; });

        // Verifica se campo deve ser exibido conforme show-on na máscara
        const isCampoVisivel = (campo) => {
            const mascara = campo.mascara || '';
            const showOnMatch = mascara.match(/show-on\[campo_extra=([^|]+)\|campo_valor=([^\]]+)\]/);
            if (!showOnMatch) return true;
            const refSlug = showOnMatch[1];
            const refValor = showOnMatch[2];
            const refId = slugToId[refSlug];
            if (refId == null) return false;
            const valorRef = this.state.valoresCamposExtraPaciente?.[refId] ?? '';
            return String(valorRef) === refValor;
        };

        return (
            <div className="mt-4 mb-3">
                {campos.map((campo) => {
                    if (!isCampoVisivel(campo)) return null;

                    const mascara = campo.mascara || '';
                    const isInfoField = mascara.includes('information-field');
                    const valorAtual = this.state.valoresCamposExtraPaciente?.[campo.id] ?? '';
                    const opcoes = String(campo.opcoes || '').split('\n').map((v) => v.trim()).filter(Boolean);

                    if (isInfoField) {
                        return (
                            <Alert variant="info" className="mb-3" key={`campo_aceite_${campo.id}`} role="status">
                                {campo.nome ? <div className="fw-semibold mb-1">{campo.nome}</div> : null}
                                {campo.descricao ? <div>{campo.descricao}</div> : null}
                            </Alert>
                        );
                    }

                    return (
                        <div className="mb-3" key={`campo_aceite_${campo.id}`}>
                            <div className="fw-bold">
                                {campo.nome}
                                <span className="text-danger ms-1">*</span>
                            </div>

                            {campo.descricao && (
                                <div className="text-muted mb-2" style={{ fontSize: '0.9em' }}>
                                    {campo.descricao}
                                </div>
                            )}

                            {(
                            campo.tipo === 'selecao' ? (
                                <Form.Control
                                    as="select"
                                    value={valorAtual}
                                    required
                                    onChange={(e) => this.handleChangeCampoAceite(campo.id, e.target.value)}
                                >
                                    <option value="">Selecione...</option>
                                    {opcoes.map((opcao, idx) => {
                                        const parsed = this.parseCampoOpcao(opcao);
                                        return <option key={`select_${campo.id}_${idx}`} value={parsed.valor}>{parsed.label}</option>;
                                    })}
                                </Form.Control>
                            ) : campo.tipo === 'radio' ? (
                                <div>
                                    {opcoes.map((opcao, idx) => {
                                        const parsed = this.parseCampoOpcao(opcao);
                                        return (
                                            <Form.Check
                                                key={`radio_${campo.id}_${idx}`}
                                                type="radio"
                                                id={`campo_aceite_radio_${campo.id}_${idx}`}
                                                name={`campo_aceite_radio_${campo.id}`}
                                                label={parsed.label}
                                                value={parsed.valor}
                                                checked={String(valorAtual) === parsed.valor}
                                                onChange={(e) => this.handleChangeCampoAceite(campo.id, e.target.value)}
                                            />
                                        );
                                    })}
                                </div>
                            ) : campo.tipo === 'checkbox' ? (
                                <div>
                                    {opcoes.map((opcao, idx) => {
                                        const parsed = this.parseCampoOpcao(opcao);
                                        const checked = String(valorAtual || '').split(',').map((v) => v.trim()).includes(parsed.valor);
                                        return (
                                            <Form.Check
                                                key={`checkbox_${campo.id}_${idx}`}
                                                type="checkbox"
                                                label={parsed.label}
                                                value={parsed.valor}
                                                checked={checked}
                                                onChange={(e) => this.handleChangeCampoAceite(campo.id, e)}
                                            />
                                        );
                                    })}
                                </div>
                            ) : campo.tipo === 'area_texto' ? (
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={valorAtual}
                                    required
                                    onChange={(e) => this.handleChangeCampoAceite(campo.id, e.target.value)}
                                />
                            ) : campo.tipo === 'data' ? (
                                <Form.Control
                                    type="date"
                                    value={valorAtual}
                                    required
                                    onChange={(e) => this.handleChangeCampoAceite(campo.id, e.target.value)}
                                />
                            ) : campo.tipo === 'numero' ? (
                                <Form.Control
                                    type="number"
                                    value={valorAtual}
                                    required
                                    onChange={(e) => this.handleChangeCampoAceite(campo.id, e.target.value)}
                                />
                            ) : campo.tipo === 'arquivo' ? (
                                <Form.Control
                                    type="file"
                                    required
                                    onChange={(e) => this.handleChangeCampoAceite(campo.id, e)}
                                />
                            ) : (
                                <Form.Control
                                    type="text"
                                    value={valorAtual}
                                    required
                                    onChange={(e) => this.handleChangeCampoAceite(campo.id, e.target.value)}
                                />
                            ))}
                        </div>
                    );
                })}
            </div>
        );
    };

    /**
     * Renderiza a seção de checkboxes do termo de programa.
     * Se houver checkboxes_personalizados na configuração, usa eles.
     * Caso contrário, usa o checkbox padrão.
     */
    renderCheckboxesPrograma() {
        const checkboxes = getConfig(
            this.state.programa_dados?.configuracoes, 
            'aceite_termos.checkboxes_personalizados', 
            null
        );
        const textoAdicional = getConfig(
            this.state.programa_dados?.configuracoes, 
            'aceite_termos.texto_adicional', 
            ''
        );

        // Se tem checkboxes personalizados configurados
        if (checkboxes && Array.isArray(checkboxes) && checkboxes.length > 0) {
            return (
                <Row className="align-items-center">
                    {!this.state.optin_data ? (
                        <>
                            <Col sm={8}>
                                {/* Primeiro checkbox com possível link */}
                                <label style={{ cursor: "pointer", display: "block", marginBottom: "10px" }}>
                                    <input
                                        type="checkbox"
                                        checked={!!this.state.checkboxesState[checkboxes[0].id]}
                                        onChange={this.handleCustomCheckboxChange(checkboxes[0].id)}
                                    />{' '}
                                    {renderCheckboxTexto(checkboxes[0])}
                                </label>

                                {/* Texto adicional entre o primeiro e os demais checkboxes */}
                                {textoAdicional && (
                                    <p className="mt-2 mb-3" style={{ fontSize: '0.95em', color: '#333' }}>
                                        {textoAdicional}
                                    </p>
                                )}

                                {/* Demais checkboxes */}
                                {checkboxes.slice(1).map((cb) => (
                                    <label key={cb.id} style={{ cursor: "pointer", display: "block", marginBottom: "10px" }}>
                                        <input
                                            type="checkbox"
                                            checked={!!this.state.checkboxesState[cb.id]}
                                            onChange={this.handleCustomCheckboxChange(cb.id)}
                                        />{' '}
                                        {renderCheckboxTexto(cb)}
                                    </label>
                                ))}
                            </Col>
                            <Col sm={4} className="text-end">
                                <button 
                                    className="btn btn-secondary mt-2"  
                                    disabled={this.state.loading || !this.todosCheckboxesMarcados()} 
                                    onClick={this.handleSubmitOptin}
                                >
                                    {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Aceitar Termos'}       
                                </button>
                            </Col>
                        </>
                    ) : (
                        <Col sm={12}>
                            <p>Termo aceito em <strong>{formataDataHoraExibicao(this.state.optin_data)}</strong></p>
                        </Col>
                    )}
                </Row>
            );
        }

        // Fallback: checkbox padrão (comportamento original)
        return (
            <Row className="align-items-center">
                {!this.state.optin_data ? (
                    <>
                    <Col sm={8}>
                        <label style={{ cursor: "pointer" }}>
                            <input
                                type="checkbox"
                                checked={this.state.optinChecked}
                                onChange={this.handleOptinChange}
                            /> Declaro que estou ciente e concordo com o Regulamento do Programa
                        </label>
                    </Col>
                    <Col sm={4} className="text-end">
                        <button className="btn btn-secondary mt-2"  disabled={this.state.loading || !this.state.optinChecked} onClick={this.handleSubmitOptin}>
                            {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Aceitar Termos'}       
                        </button>
                    </Col>
                    </>
                ) : (
                    <Col sm={12}>
                        <p>Termo aceito em <strong>{formataDataHoraExibicao(this.state.optin_data)}</strong></p>
                    </Col>
                )}
            </Row>
        );
    }

    render(){

        if(this.state.loading) {
            return(
                <div className="container">
                    <Row className="mt-5 align-items-center justify-content-center">
                        <Col sm={8} lg={8}>
                            <h1 className="page-title title-termo text-center mb-5">Carregando Termo</h1>
                            {!this.state.erroLoadRegistro ? (
                                <p className="text-center text-muted">Aguarde…</p>
                            ) : (
                                <div className="alert alert-warning">
                                    {this.state.erroLoadRegistro}
                                    <div className="mt-3 d-flex gap-2">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => window.location.reload()}
                                        >
                                            Recarregar
                                        </button>
                                    </div>
                                </div>
                            )}
                        </Col>
                    </Row>
                </div>
            )
        }        

        return (
            <div className="container">
                {this.state.debugEnabled && (
                    <div className="alert alert-warning mt-3">
                        <strong>DEBUG:</strong> isIOS={String(this.state.isIOS)} | forceIOS={String(this.state.forceIOS)}
                    </div>
                )}
                <Row className="mt-2 align-items-center justify-content-center">
                    <Col sm={8} lg={8}>
                        {this.state.programa_imagem_branca && (
                            <div className="mb-3 text-center">
                                <img src={this.state.programa_imagem_branca} alt={this.state.programa_nome} style={{ maxWidth: '200px' }} />
                            </div>
                        )}
                        <h1 className="page-title title-termo text-center mb-5">Aceite de Termo do Programa {this.state.programa_nome}</h1>                        
                        <Card className="cardDestaque">                            
                            <Card.Body className="p-4">   
                                {!(this.state.isMobile) && (    
                                    <div className="d-none d-sm-block">
                                        {this.state.termoParam === 'programa' && (
                                            this.state.optin_data ? (
                                                <embed src={this.state.termo_paciente_pdf_comprovante} type="application/pdf" width="100%" height="600px" />
                                            ) : (
                                                <embed src={this.state.programa_termo_paciente_pdf ? this.state.programa_termo_paciente_pdf : this.state.termo_programa_pdf} type="application/pdf" width="100%" height="600px" />
                                            )
                                        )}
                                        {this.state.termoParam === 'laboratorio' && !this.state.lets_sign_documento_id && this.state.pdf_termo_prestador && (
                                            <embed src={this.state.optin_data_laboratorio ? this.state.termo_prestador_pdf_comprovante : this.state.pdf_termo_prestador} type="application/pdf" width="100%" height="600px" />
                                        )}
                                    </div>
                                )}
                                {(this.state.isMobile) && (
                                    <div className="d-block d-sm-none">
                                        {this.state.termoParam === 'programa' && (
                                        <a href={this.state.optin_data ? this.state.termo_paciente_pdf_comprovante : this.state.programa_termo_paciente_pdf ? this.state.programa_termo_paciente_pdf : this.state.termo_programa_pdf} className="btn btn-sm btn-secondary" target="_blank" rel="noopener noreferrer">
                                            Abrir Termo do Programa
                                        </a>
                                        )}
                                        {this.state.termoParam === 'laboratorio' && !this.state.lets_sign_documento_id && this.state.pdf_termo_prestador && (
                                        <a href={this.state.optin_data_laboratorio ? this.state.termo_prestador_pdf_comprovante : this.state.pdf_termo_prestador} className="btn btn-sm btn-secondary" target="_blank" rel="noopener noreferrer">
                                            Abrir Termo de Consentimento do Laboratório
                                        </a>
                                        )} 
                                    </div>    
                                )}     

                                {this.renderCamposAceiteTermos()}

                                
                                <div className="mt-3">
                                    {this.state.termoParam === 'laboratorio' ? (
                                        <Row className="align-items-center">
                                            {!this.state.optin_data_laboratorio ? (
                                                <>
                                                    <Col sm={8}>
                                                        <label style={{ cursor: "pointer" }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={this.state.optinChecked}
                                                                onChange={this.handleOptinChange}
                                                            /> Confirmo que li e estou de acordo com os Termos de Consentimento do Laboratório
                                                        </label>
                                                    </Col>
                                                    <Col sm={4} className="text-end">
                                                        <button className="btn btn-secondary mt-2"  disabled={this.state.loading || !this.state.optinChecked} onClick={this.handleSubmitOptinLaboratorio}>
                                                            {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Aceitar Termos'}       
                                                        </button>
                                                    </Col>
                                                </>
                                            ) : (
                                                <Col sm={12}>
                                                    <p>Termo aceito em <strong>{formataDataHoraExibicao(this.state.optin_data_laboratorio)}</strong></p>
                                                </Col>
                                            )}
                                        </Row>
                                    ) : (
                                        // Usa o método que decide entre personalizado ou padrão
                                        this.renderCheckboxesPrograma()
                                    )}
                                </div>
                            </Card.Body>
                        </Card>

                        {this.state.programa_imagem_branca && (
                            <div className="mt-5 text-center">
                                <p>Powered by <a href="https://aditushealth.com.br" target="_blank" rel="noreferrer"><img src={logomarca} alt="Aditus Health" style={{ maxWidth: '60px' }} /></a></p>
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
        )
    }
}

export default withRouter(TermosAceite);